export function getEnquirePageType() {
  const ele = document.querySelector<HTMLElement>("[data-enquire-page-type]");
  const defaultType = 0;
  if (!ele) return defaultType;
  const val = Number(ele.dataset.enquirePageType);
  return val ?? defaultType;
}
